import { Component, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppUtilityService } from '../../services/app-utility.service';
import { ComponentInstanceService } from '../../services/component-instance.service';
import { GlobalsService } from '../../services/globals.service';
import { HeaderBar, HeaderBarService } from '../../services/header-bar.service';
import { ApiService } from '../../services/api-mock.service';
import {
 
  ScreenModel,
 
} from '../../../core/models/common';

@Component({
  selector: 'app-header-bar',
  templateUrl: './header-bar.component.html',
  styleUrls: ['./header-bar.component.scss'],
})
export class HeaderBarComponent {
  title = 'Financial Needs Analysis';

  constructor(
    private router: Router,
    public globals: GlobalsService,
    private componentInstance: ComponentInstanceService,
    private headerBarService: HeaderBarService,
    private modalService: NgbModal,
    private apiService: ApiService,
    private el: ElementRef,
    private appUtility: AppUtilityService,
  ) {}

  async onClickSaveAsDraft() {
    const currentInstance = this.componentInstance.current;

    if (
      currentInstance.model &&
      typeof currentInstance.model.onSaveAsDraft == 'function'
    ) {
      await currentInstance.model.onSaveAsDraft();
    }

    if (this.globals.isMobile) {
      this.globals.showLastTimeSavedMobile = true;
      this.globals.showLastSaveTime();
    }
  }

  async onClickSaveAndExit(content: any) {
    const model = new ScreenModel(this.globals, this.apiService, this.el);
    this.modalService.open(content).result.then(
      async (result) => {
        //await this.onClickSaveAsDraft();
        await model.callMiscService('R9999',{})
        localStorage.setItem('DFNA-tokenID','');
        await this.appUtility.logout({});
      },
      (reason) => {},
    );
  }

  get headerBarState(): HeaderBar {
    return this.headerBarService.headerBarState;
  }

  get headerBar(): typeof HeaderBar {
    return HeaderBar;
  }
}
